const EMAIL_MD5_LABEL = 'Email/md5';

const joinFieldNames = (names) => {
  if (names.length <= 1) return names[0] || '';
  if (names.length === 2) return `${names[0]} and ${names[1]}`;
  return `${names.slice(0, -1).join(', ')}, and ${names[names.length - 1]}`;
};

/**
 * If Email/md5 or included org properties share a 1-based column number, return a
 * descriptive error for the upload dialog; otherwise null.
 */
export const getUniverseDuplicateColumnError = ({
  emailMd5Column,
  properties = [],
  propertyColumns = {},
  propertyExcluded = {},
} = {}) => {
  const labelsByColumn = new Map();
  const add = (col, label) => {
    const key = String(col ?? '').trim();
    if (!key || !label) return;
    const list = labelsByColumn.get(key) || [];
    list.push(label);
    labelsByColumn.set(key, list);
  };

  add(emailMd5Column, EMAIL_MD5_LABEL);
  properties.forEach((p) => {
    if (!p?.name || propertyExcluded[p.name]) return;
    add(propertyColumns[p.name], p.display_name || p.name);
  });

  const conflicts = [...labelsByColumn.entries()].filter(([, labels]) => labels.length > 1);
  if (conflicts.length === 0) return null;

  const details = conflicts.map(
    ([col, labels]) => `${joinFieldNames(labels)} are mapped to column ${col}`
  );
  if (details.length === 1) {
    return `${details[0]}. Each field must use a different column.`;
  }
  return (
    `Some fields are mapped to the same column:\n${details.map((d) => `• ${d}.`).join('\n')}\n` +
    'Each field must use a different column.'
  );
};
